// Ascension Brand Colors
// https://www.figma.com/file/FDaCA02JPjEqvKuCU8dgtJ/DS-Foundations-1.0.0---WIP?node-id=0%3A1

const common = {
  black: '#000',
  white: '#fff',
}

const primary = {
  50: '#E8F5FE',
  100: '#D1EAFC',
  200: '#A4D3FA',
  300: '#75B3F1',
  400: '#5194E3',
  500: '#1E69D2',
  600: '#1551B4',
  700: '#0F3C97',
  800: '#092A79',
  900: '#051D64',
  light: '#75B3F1',
  main: '#1E69D2',
  dark: '#0F3C97',
  overlay: 'rgba(30, 105, 210, 0.85)',
}

const secondary = {
  50: '#FDE6EE',
  100: '#FBCDDC',
  200: '#F79CC4',
  300: '#E868AC',
  400: '#D2419C',
  500: '#B40F87',
  600: '#9A0A81',
  700: '#810778',
  800: '#660468',
  900: '#4C0256',
  light: '#E868AC',
  main: '#B40F87',
  dark: '#810778',
  overlay: 'rgba(180, 15, 135, 0.85)',
}

const grey = {
  50: '#FAFAFA',
  100: '#F5F5F5',
  200: '#EEEEEE',
  300: '#E0E0E0',
  400: '#BDBDBD',
  500: '#9E9E9E',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
}

const error = {
  50: '#FEE7E5',
  100: '#FDD7CA',
  200: '#FBA797',
  300: '#F56C62',
  400: '#EC3B3E',
  500: '#E00019',
  600: '#C00027',
  700: '#A1002F',
  800: '#810032',
  900: '#6B0033',
  light: '#F56C62',
  main: '#E00019',
  dark: '#A1002F',
}

const warning = {
  50: '#FFF7E6',
  100: '#FFEFCC',
  200: '#FFDB99',
  300: '#FFC166',
  400: '#FFA83F',
  500: '#FF7F00',
  600: '#DB6200',
  700: '#B74900',
  800: '#933300',
  900: '#7A2400',
  light: '#FFC166',
  main: '#FF7F00',
  dark: '#B74900',
}

const success = {
  50: '#E9FBE7',
  100: '#D4F8D0',
  200: '#A4F2A4',
  300: '#70D87B',
  400: '#46B25C',
  500: '#198038',
  600: '#126E36',
  700: '#0C5C34',
  800: '#074A2F',
  900: '#043D2C',
  light: '#70D87B',
  main: '#126E36',
  dark: '#074A2F',
}

const gold = {
  300: '#FFD266',
  400: '#FFC333',
  500: '#FFB400',
  light: '#FFD266',
  main: '#FFC333',
  dark: '#FFB400',
  overlay: 'rgba(255, 180, 0, 0.85)',
}

const green = {
  300: '#66CABD',
  400: '#33B9A7',
  500: '#00A791',
  700: '#00806D',
  light: '#66CABD',
  main: '#00A791',
  dark: '#00806D',
  overlay: 'rgba(0, 128, 109, 0.85)',
}

const brand = {
  primary,
  secondary,
  success,
  warning,
  error,
  grey,
  gold,
  green,
  gradient: {
    blue: {
      0: '#1B4297',
      100: '#1E69D2',
    },
  },
  action: {
    disabled: 'rgba(0,0,0,0.5)',
    disabledBackground: 'rgba(0,0,0,0.5)',
  },
}

export const colors = {
  common,
  primary,
  secondary,
  grey,
  error,
  warning,
  success,
  brand,
}
